module.exports = __webpack_public_path__ + "static/media/educatec preto.6e97e1a0.png";